var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 22,
    viewBox: "0 0 52 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7752 11.3091C51.7752 7.62734 49.9918 4.72217 46.5833 4.72217C43.1604 4.72217 41.0894 7.62734 41.0894 11.2804C41.0894 15.6094 43.5343 17.7954 47.0435 17.7954C48.755 17.7954 50.0494 17.4071 51.0273 16.8606V13.9842C50.0494 14.4732 48.9276 14.7752 47.5037 14.7752C46.1087 14.7752 44.8718 14.2862 44.7136 12.5891H51.7464C51.7464 12.4022 51.7752 11.6543 51.7752 11.3091ZM44.6705 9.94284C44.6705 8.31767 45.6628 7.64172 46.5689 7.64172C47.4462 7.64172 48.381 8.31767 48.381 9.94284H44.6705Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5381 4.72217C34.1286 4.72217 33.2225 5.38374 32.7192 5.84397L32.5322 4.95228H29.3682V21.7217L32.9637 20.9595L32.978 16.8894C33.4958 17.2633 34.258 17.7954 35.5237 17.7954C38.0981 17.7954 40.4423 15.7244 40.4423 11.1653C40.4279 6.99453 38.0549 4.72217 35.5381 4.72217ZM34.6751 14.6314C33.8266 14.6314 33.3232 14.3294 32.978 13.9554L32.9637 8.6197C33.3376 8.20262 33.8554 7.91498 34.6751 7.91498C35.9839 7.91498 36.89 9.38194 36.89 11.266C36.89 13.1932 35.9983 14.6314 34.6751 14.6314Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4207 3.87367L28.0305 3.09704V0.17749L24.4207 0.939737V3.87367Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0305 4.9668H24.4207V17.5511H28.0305V4.9668Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.552 6.03104L20.3218 4.96678H17.2153V17.551H20.8108V9.02251C21.6594 7.91509 23.0976 8.11644 23.5434 8.27464V4.96678C23.0832 4.79419 21.4005 4.47779 20.552 6.03104Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.361 1.8457L9.85178 2.59357L9.8374 14.1136C9.8374 16.2421 11.4338 17.8097 13.5623 17.8097C14.7417 17.8097 15.6046 17.594 16.0792 17.3351V14.4156C15.619 14.6026 13.3466 15.2641 13.3466 13.1356V8.02997H16.0792V4.9666H13.3466L13.361 1.8457Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.63865 8.6197C3.63865 8.0588 4.09888 7.84307 4.86112 7.84307C5.95416 7.84307 7.33483 8.17385 8.42787 8.76352V5.38374C7.23416 4.90913 6.05483 4.72217 4.86112 4.72217C1.94157 4.72217 0 6.24666 0 8.79228C0 12.7617 5.46517 12.1289 5.46517 13.8404C5.46517 14.5019 4.88989 14.7177 4.08449 14.7177C2.89079 14.7177 1.36629 14.2287 0.158202 13.5671V16.99C1.49573 17.5653 2.84764 17.8098 4.08449 17.8098C7.07596 17.8098 9.13258 16.3285 9.13258 13.7541C9.1182 9.46824 3.63865 10.2305 3.63865 8.6197Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe_logo.7c4148d082223986855b5f4c19fbd552.svg";
export { ForwardRef as ReactComponent };